__turbopack_context__.v({
  "className": "inter_c2348cbb-module__SySpKq__className",
  "variable": "inter_c2348cbb-module__SySpKq__variable",
});
